import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import _forEach from "lodash/forEach";
import Button from "components/Buttons";
import Row from "components/Row";
import Input from "components/gads/Input";
import Dropdown from "components/Dropdown";
import Loading from "components/gads/Loading";
import Toast from "components/Toast";
import googleActions from "modules/google/actions";
import googleSelectors from "modules/google/selectors";
import facebookActions from "modules/facebook/actions";
import facebookSelectors from "modules/facebook/selectors";
import dateFormatter from "modules/utils/DateFormatter";
import decodeHTMLEntities from "modules/utils/DecodeHTMLEntities";

const CRMConversionCrm = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const rmpToken = sessionStorage.getItem("rmp_token");
  const [loading, setLoading] = useState(true);
  const businessPipelinesResult = useSelector((state) => googleSelectors.getBusinessPipelinesResult(state));
  const businessStepsResult = useSelector((state) => googleSelectors.getBusinessStepsResult(state));
  const facebookConversionLastSent = useSelector((state) =>
    facebookSelectors.getFacebookCRMConversionLastSentResult(state),
  );
  const [currentPipeline, setCurrentPipeline] = useState("");
  const [defaultPipeline, setDefaultPipeline] = useState(0);
  const dropdownItems = [
    {
      title: "-",
    },
  ];
  const [selectedRadioValue, setSelectedRadioValue] = useState("");
  const [lastSendDatetimes, setLastSendDatetimes] = useState({});
  const [formStandard, setFormStandard] = useState();
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showFailedToast, setShowFailedToast] = useState(false);
  const [submitFBRCRMLoading, setSubmitFBRCRMLoading] = useState(false);
  const menu = "facebook_ads_crm_conversion";
  const tab = "r-crm";

  const handleSelectedRadioValue = (value) => {
    if (menu === sessionStorage.getItem("selectedMenu") && tab === sessionStorage.getItem("selectedTab")) {
      setSelectedRadioValue(value);
    }
  };

  const handleCurrentPipeline = (value) => {
    if (menu === sessionStorage.getItem("selectedMenu") && tab === sessionStorage.getItem("selectedTab")) {
      setCurrentPipeline(value);
    }
  };

  const handleDefaultPipeline = (value) => {
    if (menu === sessionStorage.getItem("selectedMenu") && tab === sessionStorage.getItem("selectedTab")) {
      setDefaultPipeline(value);
    }
  };

  const handleLastSendDatetimes = (value) => {
    if (menu === sessionStorage.getItem("selectedMenu") && tab === sessionStorage.getItem("selectedTab")) {
      setLastSendDatetimes(value);
    }
  };

  const handleFormStandard = (value) => {
    if (menu === sessionStorage.getItem("selectedMenu") && tab === sessionStorage.getItem("selectedTab")) {
      setFormStandard(value);
    }
  };

  // Get Pipelines & Lead Source
  useEffect(() => {
    setLoading(true);

    async function fetchData() {
      const pipelines = await dispatch(
        googleActions.getBusinessPipelines({
          token: rmpToken,
        }),
      );

      _forEach(pipelines.data, (value, key) => {
        if (value.default_pipeline === "Y") {
          handleCurrentPipeline(parseInt(key));
          handleDefaultPipeline(parseInt(key));
        }
      });
    }

    fetchData();
  }, []);

  // Get Steps
  useEffect(() => {
    if (businessPipelinesResult.data.length > 0 && currentPipeline !== "") {
      dispatch(
        googleActions.getBusinessSteps({
          token: rmpToken,
          lead_pipeline_id: businessPipelinesResult.data[currentPipeline].id,
          lang: sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en",
        }),
      );
    }
  }, [businessPipelinesResult, currentPipeline]);

  useEffect(() => {
    getFbBusinessStepsResult();
    setLoading(false);
  }, [businessStepsResult, facebookConversionLastSent, currentPipeline]);

  const getFbBusinessStepsResult = async () => {
    let lastSend = {};

    if (businessPipelinesResult.data.length > 0 && currentPipeline !== "") {
      const fbBusinessStepsResult = await dispatch(
        facebookActions.getFacebookConversionSettingByPipeline({
          token: rmpToken,
          pipelineId: businessPipelinesResult.data[currentPipeline].id,
        }),
      );

      if (fbBusinessStepsResult.result === 0 && fbBusinessStepsResult.data.length > 0) {
        let status = fbBusinessStepsResult.data[0].crm_conversion;
        handleSelectedRadioValue(status);

        if (facebookConversionLastSent.data != undefined && facebookConversionLastSent.data.length > 0) {
          fbBusinessStepsResult.data.forEach((e, i) => {
            facebookConversionLastSent.data.find(function (item, index) {
              if (item.conversion_name === e.conversion_name) {
                lastSend[item.conversion_name] = dateFormatter.formatDatetimeFull(
                  item.last_sent_datetime,
                  sessionStorage.getItem("lang"),
                );
              }
            });
          });
          handleLastSendDatetimes({ ...lastSend });
        }
      } else {
        // If no data in Facebook Conversion Setting, set default value to inactive
        let status = "inactive";
        handleSelectedRadioValue(status);
      }
      return fbBusinessStepsResult;
    }
  };

  const fetchData = async () => {
    if (businessStepsResult.result == 0 && businessPipelinesResult.result == 0) {
      if (businessPipelinesResult.data.length > 0 && currentPipeline !== "") {
        const fbBusinessStepsResult = await dispatch(
          facebookActions.getFacebookConversionSettingByPipeline({
            token: rmpToken,
            pipelineId: businessPipelinesResult.data[currentPipeline].id,
          }),
        );

        if (fbBusinessStepsResult.result == 0) {
          let standard = businessStepsResult.data;
          let newStandard = [];

          standard.map((e) => {
            const data = businessStepsResult.data;
            const resData = data.filter((eData) => eData.conversions_name == e.conversions_name);

            if (resData.length > 0) {
              e.conversion_value = "0.00";
              newStandard.push({
                ...e,
                conversion_name: e.conversions_name,
                error: false,
                name: resData[0].name,
                folder: resData[0].folder,
                following: resData[0].following,
              });
            }
          });

          handleFormStandard(newStandard);
        }
      }
    }
  };

  // init input fields
  useEffect(() => {
    fetchData();
  }, [businessStepsResult, currentPipeline]);

  const RenderFormContentTable = (form, index) => {
    return form.following === "Y" && index === 0 ? (
      <>
        <tr className="rcrm-parent-title">
          <td colSpan="2">{t("__ads_crm_following_lead")}</td>
        </tr>
        <tr className="rcrm-title">
          <td>{t("__ads_crm_lead_step")}</td>
          <td>{t("__ads_crm_conversion_name")}</td>
        </tr>
        <tr key={index}>
          <td>{decodeHTMLEntities(form.name)}</td>
          <td>
            <div>{form.conversion_name}</div>

            <div className="secondary-text">
              {t("__ads_crm_conversion_last_update")}:{" "}
              {lastSendDatetimes[form.conversion_name]
                ? lastSendDatetimes[form.conversion_name]
                : t("__fbads_conversion_no_data")}
            </div>
          </td>
        </tr>
      </>
    ) : form.following === "Y" && form.folder === "close_win" ? (
      <>
        <tr key={index}>
          <td>{decodeHTMLEntities(form.name)}</td>
          <td>
            <div>{form.conversion_name}</div>

            <div className="secondary-text">
              {t("__ads_crm_conversion_last_update")}:{" "}
              {lastSendDatetimes[form.conversion_name]
                ? lastSendDatetimes[form.conversion_name]
                : t("__fbads_conversion_no_data")}
            </div>
          </td>
        </tr>
        <tr className="rcrm-parent-title">
          <td colSpan="2">{t("__ads_crm_unfollowed_lead")}</td>
        </tr>
        <tr className="rcrm-title">
          <td>{t("__ads_crm_lead_step")}</td>
          <td>{t("__ads_crm_conversion_name")}</td>
        </tr>
      </>
    ) : (
      <tr key={index}>
        <td>{decodeHTMLEntities(form.name)}</td>
        <td>
          <div>{form.conversion_name}</div>

          <div className="secondary-text">
            {t("__ads_crm_conversion_last_update")}:{" "}
            {lastSendDatetimes[form.conversion_name]
              ? lastSendDatetimes[form.conversion_name]
              : t("__fbads_conversion_no_data")}
          </div>
        </td>
      </tr>
    );
  };

  const handleLeadConversionStatusChange = (e) => {
    setSelectedRadioValue(e.target.value);
  };

  const handleOnSelectPipeline = async (item, index) => {
    setCurrentPipeline(index);
  };

  const handleLeadConversions = async () => {
    try {
      setSubmitFBRCRMLoading(true);
      setShowFailedToast(false);
      setShowSuccessToast(false);

      let formStandardClone = [];

      if (formStandard != undefined) {
        formStandardClone = formStandard.map((std) => {
          return { ...std };
        });
        formStandardClone.forEach((e) => {
          e.conversion_value = "0.00";
          e.conversion_value = parseFloat(e.conversion_value).toFixed(2);
        });
      }

      const conversions = await dispatch(
        facebookActions.setFacebookConversionSettingStatus({
          token: rmpToken,
          pipelineId: businessPipelinesResult.data[currentPipeline].id,
          pipelineSteps: formStandardClone,
          conversionStatus: selectedRadioValue,
          conversionType: "crm",
        }),
      );

      if (conversions.result === 0) {
        setSubmitFBRCRMLoading(false);
        setShowSuccessToast(true);
      } else {
        setSubmitFBRCRMLoading(false);
        setShowFailedToast(true);
      }
    } catch (error) {
      console.error("Error in handleLeadConversions:", error);
    }
  };

  const successToastCallback = (value) => {
    setShowSuccessToast(value);
  };

  const failedToastCallback = (value) => {
    setShowFailedToast(value);
  };

  const submit = (e) => {
    e.preventDefault();
    handleLeadConversions();
  };

  let view;

  if (loading === true) {
    view = () => {
      return (
        <>
          <Loading />
        </>
      );
    };
  } else {
    view = () => {
      return (
        <>
          <Description>{t("__fbads_crm_description")}</Description>
          <form id="settingFacebook">
            <ConversionSettingHeader>
              <div className="w-50">
                <label className="secondary-text">{t("__ads_crm_lead_pipeline")}</label>
                <Dropdown
                  items={businessPipelinesResult.data.length > 0 ? businessPipelinesResult.data : dropdownItems}
                  onSelected={handleOnSelectPipeline}
                  defaultIndex={defaultPipeline}
                  minWidth="100%"
                />
              </div>
              <div className="w-50 d-flex flex-col">
                <label className="secondary-text">{t("__fbads_rcrm_conversion_sync")}</label>
                <div className="d-flex radioContainer">
                  <RadioLabelContainer>
                    <input
                      className="cursor-pointer"
                      id="sync_facebook_ads"
                      type="radio"
                      name="sync_facebook_ads"
                      onChange={handleLeadConversionStatusChange}
                      checked={selectedRadioValue == "active"}
                      value="active"
                      form="settingFacebook"
                    />
                    <label className="cursor-pointer" htmlFor="sync_facebook_ads">
                      {t("__ads_crm_conversion_send_data")}
                    </label>
                  </RadioLabelContainer>

                  <RadioLabelContainer>
                    <input
                      className="cursor-pointer"
                      id="not_sync_facebook_ads"
                      type="radio"
                      name="sync_facebook_ads"
                      onChange={handleLeadConversionStatusChange}
                      checked={selectedRadioValue == "inactive"}
                      value="inactive"
                      form="settingFacebook"
                    />
                    <label className="cursor-pointer" htmlFor="not_sync_facebook_ads">
                      {t("__ads_crm_conversion_unsend_data")}
                    </label>
                  </RadioLabelContainer>
                </div>
              </div>
            </ConversionSettingHeader>

            <Table>
              <thead>
                <tr>
                  <th className="r-crm-title" colSpan="1">
                    R-CRM
                  </th>
                  <th className="google-ads-title" colSpan="1">
                    Meta Ads
                  </th>
                </tr>
              </thead>
              <tbody>
                {formStandard &&
                  formStandard.map((form, index) => {
                    return <React.Fragment key={index}>{RenderFormContentTable(form, index)}</React.Fragment>;
                  })}
              </tbody>
            </Table>

            <BottomSticky>
              <RowAlignRight alignItems="stretch">
                <Button type="loading" onClick={(e) => submit(e)} loading={submitFBRCRMLoading}>
                  {t("__ads_setup_save")}
                </Button>
              </RowAlignRight>
            </BottomSticky>
          </form>

          <Toast
            show={showSuccessToast}
            message={t("__ads_crm_conversion_save_success")}
            bgColor="#4CAF50"
            callback={successToastCallback}
          ></Toast>
          <Toast
            show={showFailedToast}
            message={t("__ads_crm_conversion_save_failed")}
            bgColor="#F44336"
            callback={failedToastCallback}
          ></Toast>
        </>
      );
    };
  }
  return view();
};

export default CRMConversionCrm;

const Description = styled.div`
  padding: 10px 0px;
  font-size: 14px;
  color: #999;
`;

const ConversionSettingHeader = styled.div`
  display: flex;
  font-size: 14px;
  margin-bottom: 10px;

  .secondary-text {
    color: #aaa;
    font-size: 12px;
  }

  .w-50 {
    width: 50%;
    padding: 0px 10px;
    text-align: left;
  }

  .d-flex {
    display: flex;
  }

  .flex-row {
    flex-direction: row;
  }

  .flex-col {
    flex-direction: column;
  }

  .space-between {
    justify-content: space-between;
  }

  .radioContainer {
    margin-top: 0.5em;
  }

  @media screen and (min-width: 320px) and (max-width: 480px) {
    flex-direction: column;

    .w-50 {
      width: 100%;
      margin-bottom: 10px;
      text-align: left;
    }
  }
`;

const RadioLabelContainer = styled.span`
  &:first-child {
    margin-right: 10px;
  }
`;

const Table = styled.table`
  border-collapse: collapse;
  border: 1px solid #eee;
  width: 100%;
  font-size: 14px;

  th,
  td {
    border: 1px solid #eee;
    padding: 10px;
    width: 50%;
  }

  .sub-title {
    background-color: #f9f9f9;
    color: #555;
    /* font-size: 12px; */
    text-align: center;
    /* padding: 5px 10px; */
  }

  .r-crm-title {
    color: #fff;
    background-color: #2196f3;
    width: 40%;
  }

  .rcrm-parent-title {
    background-color: #eeeeee;
    text-align: center;
    color: #555;
  }

  .rcrm-title {
    background-color: #f9f9f9;
    color: #555;
    text-align: center;
  }

  .google-ads-title {
    color: #fff;
    background-color: #4caf50;
  }

  .secondary-text {
    color: #aaa;
    font-size: 12px;
  }
`;

const BottomSticky = styled.div`
  position: sticky;
  bottom: -16px;
  padding: 10px;
  width: 100%;
  background: #fff;

  @media screen and (min-width: 320px) and (max-width: 480px) {
    overflow-y: hidden;
    left: 0;
    right: 0;
    margin: 0px -16px;
  }
`;

const RowAlignRight = styled(Row)`
  justify-content: flex-end;
`;
